import z from 'zod'
import { type ReactElement, type PropsWithChildren, type ReactNode } from 'react'
import { isDefined, type AuditProps } from '@terros/common'
import { useStoredQuery } from '@hooks'
import { useTranslation } from '@front/model'
import { TSectionList } from '../terros/section/TSectionList'
import { AuditInfoSection } from './AuditInfo'

type Props = PropsWithChildren<
  {
    fixedChildren?: ReactNode
  } & AuditProps
>
export const TAuditInfoSection = ({ children, fixedChildren, ...props }: Props): ReactElement => {
  const { t } = useTranslation()

  const { value: isCollapsed, setValue: setIsCollapsed } = useStoredQuery({
    defaultValue: true,
    storedKey: 'AuditInfo.IsCollapsed',
    urlKey: 'collapseAuditInfo',
    schema: z.boolean(),
  })

  return (
    <TSectionList
      heading={{ title: t('Audit Info') }}
      collapsibleProps={isDefined(children) ? { isCollapsed, setIsCollapsed } : undefined}
      fixedChildren={
        <>
          {fixedChildren}
          <AuditInfoSection {...props} />
        </>
      }
    >
      {children}
    </TSectionList>
  )
}
